import { useEffect, useState } from 'react';

const hours = Array.from({ length: 12 }, (_, i) => String(i + 1));
const minutes = Array.from({ length: 60 }, (_, i) => String(i).padStart(2, '0'));

function parts(value) {
  const match = /^([01]\d|2[0-3]):([0-5]\d)$/.exec(value || '');
  if (!match) return { hour: '', minute: '00', period: 'AM' };
  const hour = Number(match[1]);
  return { hour: String(hour % 12 || 12), minute: match[2], period: hour < 12 ? 'AM' : 'PM' };
}

export default function TimePicker12({ value = '', onChange, required = false, disabled = false, size = 'sm', className = '', style, id, title, 'aria-label': label = 'Time' }) {
  const [draft, setDraft] = useState(() => parts(value));
  useEffect(() => setDraft(parts(value)), [value]);

  const update = (field, selected) => {
    const next = { ...draft, [field]: selected };
    setDraft(next);
    const hour24 = (Number(next.hour) % 12) + (next.period === 'PM' ? 12 : 0);
    onChange?.({ target: { value: next.hour ? `${String(hour24).padStart(2, '0')}:${next.minute}` : '' } });
  };

  const selectClass = `form-select${size === 'sm' ? ' form-select-sm' : ''}`;
  return (
    <div role="group" aria-label={label} title={title} className={`d-flex flex-wrap gap-1 ${className}`.trim()} style={style}>
      <select id={id} className={selectClass} aria-label={`${label} hour`} value={draft.hour} onChange={(e) => update('hour', e.target.value)} required={required} disabled={disabled} style={{ minWidth: 62 }}>
        <option value="">Hour</option>
        {hours.map((hour) => <option key={hour} value={hour}>{hour}</option>)}
      </select>
      <select className={selectClass} aria-label={`${label} minute`} value={draft.minute} onChange={(e) => update('minute', e.target.value)} disabled={disabled} style={{ minWidth: 66 }}>
        {minutes.map((minute) => <option key={minute} value={minute}>{minute}</option>)}
      </select>
      <select className={selectClass} aria-label={`${label} AM or PM`} value={draft.period} onChange={(e) => update('period', e.target.value)} disabled={disabled} style={{ minWidth: 70 }}>
        <option value="AM">AM</option><option value="PM">PM</option>
      </select>
    </div>
  );
}

export function DateTimePicker12({ value = '', onChange, required = false, disabled = false, size = 'sm', min, onBlur, title, 'aria-label': label = 'Date and time' }) {
  const [draft, setDraft] = useState(() => ({ date: value.split('T')[0] || '', time: value.split('T')[1] || '' }));
  useEffect(() => setDraft({ date: value.split('T')[0] || '', time: value.split('T')[1] || '' }), [value]);
  const update = (field, selected) => {
    const next = { ...draft, [field]: selected };
    setDraft(next);
    onChange?.({ target: { value: next.date && next.time ? `${next.date}T${next.time}` : '' } });
  };
  return (
    <div className="d-flex flex-wrap gap-2" title={title} onBlur={onBlur}>
      <input type="date" className={`form-control${size === 'sm' ? ' form-control-sm' : ''}`} aria-label={`${label} date`} value={draft.date} min={min?.slice(0, 10)} required={required} disabled={disabled} onChange={(e) => update('date', e.target.value)} style={{ width: 'auto', minWidth: 145 }} />
      <TimePicker12 aria-label={`${label} time`} value={draft.time} onChange={(e) => update('time', e.target.value)} required={required} disabled={disabled} size={size} />
    </div>
  );
}
